type Address = {
  address1?: string;
  address2?: string;
  city?: string;
  state?: string;
  postalCode?: string;
};

export const DEFAULT_DUMMY_POSTAL_CODE = '00000';

export const normalizePostalCode = (
  value: string | undefined,
): string | undefined => {
  const postalCode = value?.trim() ?? '';
  if (!/^\d{5}(-\d{4})?$/.test(postalCode)) {
    return undefined;
  }
  return postalCode.slice(0, 5) === DEFAULT_DUMMY_POSTAL_CODE
    ? undefined
    : postalCode;
};

export const isPostalCodeReal = (value: string | undefined): boolean =>
  normalizePostalCode(value) !== undefined;

/**
 * @param address - Address object with optional fields
 * @returns Formatted address string with street on first line and city/state/zip on second line
 */
export const formatAddress = (address: Address): string => {
  const { address1, address2, city, state, postalCode } = address;
  const streetLine = [address1, address2].filter(Boolean).join(', ');
  const cityStateLine = [city, state].filter(Boolean).join(', ');
  const fullCityLine = [cityStateLine, postalCode].filter(Boolean).join(' ');
  return [streetLine, fullCityLine].filter(Boolean).join('\n');
};
